
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30 28.5c5.523 0 10-3.806 10-8.5s-4.477-8.5-10-8.5-10 3.806-10 8.5c0 1.741.616 3.36 1.672 4.708L20 28.5l4.896-1.19A11.315 11.315 0 0030 28.5zm-5.56-6.47c.947 0 1.714-.755 1.714-1.686 0-.931-.767-1.686-1.714-1.686-.946 0-1.713.755-1.713 1.686 0 .931.767 1.686 1.713 1.686zm7.42-1.686c0 .931-.767 1.686-1.713 1.686-.946 0-1.713-.755-1.713-1.686 0-.931.767-1.686 1.713-1.686.947 0 1.714.755 1.714 1.686zm4.001 1.686c.946 0 1.713-.755 1.713-1.686 0-.931-.767-1.686-1.713-1.686-.946 0-1.713.755-1.713 1.686 0 .931.767 1.686 1.713 1.686z","fill":"#E7E5EC"}})])
          )
        }
      }
    